export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle
        cx="8"
        cy="8"
        r="8"
        fill="#3483FA"
      />
      <path 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.03 12.121H8.97L8.727 6.78797H7.273L7.03 12.121Z"
        fill="white"
      />
      <path 
        d="M8 5.849C8.55228 5.849 9 5.40128 9 4.849C9 4.29671 8.55228 3.849 8 3.849C7.44772 3.849 7 4.29671 7 4.849C7 5.40128 7.44772 5.849 8 5.849Z"
        fill="white"
      />
    </svg>
  )
}

export function CupIcon() {
  return (
    <svg viewBox="0 0 32 32" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="#42A215">
      <g strokeWidth="1.0" fillRule="evenodd">
        <path
          d="M8.18 4.4l0.766 6.886c0.402 3.573 3.407 6.325 7.054 6.325s6.652-2.752 7.051-6.293l0.003-0.032 0.764-6.886h-15.636zM9.934 17.81c-5.573-2.329-9.5-7.566-9.902-13.763l-0.002-0.047h5.692l-0.036-0.334c-0.006-0.050-0.009-0.107-0.009-0.166 0-0.828 0.671-1.5 1.499-1.5h17.648c0.828 0 1.499 0.672 1.499 1.5 0 0.058-0.003 0.116-0.010 0.173l0.001-0.007-0.034 0.334h5.692c-0.404 6.244-4.331 11.481-9.798 13.771l-0.106 0.039c-1.128 0.944-2.499 1.635-4.005 1.968l-0.063 0.012v4.21h3.116c0 0 0.001 0 0.001 0 1.757 0 3.249 1.133 3.787 2.708l0.008 0.028 1.088 3.264h-20l1.088-3.264c0.546-1.603 2.038-2.736 3.795-2.736 0 0 0.001 0 0.001 0h3.116v-4.212c-1.568-0.345-2.939-1.037-4.081-1.992l0.015 0.012zM6.854 13.066c-0.126-0.43-0.228-0.944-0.288-1.47l-0.004-0.044-0.506-4.552h-3.060c0.759 2.412 2.095 4.46 3.849 6.056l0.011 0.010zM25.944 7l-0.506 4.552c-0.064 0.57-0.166 1.084-0.308 1.581l0.016-0.067c1.763-1.606 3.097-3.654 3.828-5.97l0.026-0.096h-3.058zM22.634 27.494c-0.218-0.641-0.815-1.094-1.518-1.094-0 0-0 0-0 0h-10.232c-0.001 0-0.001 0-0.002 0-0.703 0-1.3 0.453-1.515 1.083l-0.003 0.011-0.034 0.106h13.34l-0.036-0.106z"
        ></path>
      </g>
    </svg>
  )
}

export function FullStar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8.29187L1.90961 10L2.5 6.38267L0 3.81841L3.4553 3.29084L5 0L6.5447 3.29187L10 3.82048L7.5 6.38163L8.09039 10L5 8.29187Z"
        fill="#1F64EB"
      />
    </svg>
  )
}

export function HalfStar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
    >
      <path
        d="M5.07203 0.0325313L6.61803 3.176L10.112 3.686L7.58403 6.157L8.18103 9.648L5.07203 8.00844L5.05603 8L5.07196 0.0323995L5.07203 0V0.0325313Z"
        fill="#EFEFEF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.072 8.026L1.937 9.679L2.537 6.177L0 3.697L3.505 3.187L5.072 0V8.026Z"
        fill="#1F64EB"
      />
    </svg>
  )
}

export function ArrowDownAndUpIcon() {
  return (
    <svg
      viewBox="0 0 32 32"
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      fill="#1F64EB"
    >
      <path d="M6.857 23.527l-3.705-3.705-1.616 1.616 6.464 6.464 6.464-6.462-1.616-1.616-3.705 3.701v-18.953h-2.286v18.955zM22.857 8.473l-3.705 3.705-1.616-1.616 6.464-6.464 0.809 0.807 5.655 5.657-1.616 1.616-3.705-3.703v18.953h-2.286v-18.955z"></path>
    </svg>
  )
}

export function FilterIcon() {
  return (
    <svg
    viewBox="0 0 32 32"
    width="14"
    height="14"
    xmlns="http://www.w3.org/2000/svg"
    fill="#1F64EB"
    >
      <path d="M15.9 22h16.1v2h-16.1c-0.479 2.301-2.491 4.005-4.9 4.005s-4.42-1.704-4.894-3.973l-0.006-0.032h-6.1v-2h6.1c0.479-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032zM18.1 8c0.48-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032h4.1v2h-4.1c-0.48 2.301-2.491 4.005-4.9 4.005s-4.421-1.704-4.894-3.973l-0.006-0.033h-18.1v-2h18.1zM23 12c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0zM11 26c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0z"></path>
    </svg>
  )
}